import { View, Text as PDFText } from '@react-pdf/renderer'

import { RoomStay } from '../../../../../types/bookingDetails'
import { Currency } from '../../../../../types/currency'
import { PriceRow, PriceRowKind, priceRows } from '../../../statement'
import { addCommaToPrice } from '../../config/functions'
import styles from './styles/index.styles'

interface PriceDetailsProps {
  data: RoomStay
  currency: Currency
}

const LABEL: Record<PriceRowKind, string> = {
  listPrice: 'Total Before Discount',
  rateDiscount: 'Rate Discount',
  additionalDiscount: 'Manual Discount',
  promotion: 'Promotion Discount (already applied)',
  changePenalty: 'Modification Penalty',
  cancelPenalty: 'Cancellation Penalty',
  total: 'Total Payable Amount'
}

const SIGN: Record<PriceRow['sign'], string> = { '': '', '-': '− ', '+': '+ ' }

const toneStyle = (row: PriceRow) => {
  if (row.isTotal) return styles.totalAmount
  if (row.tone === 'discount') return styles.discountAmount
  if (row.tone === 'penalty') return styles.penaltyAmount
  return styles.lineAmount
}

// The same statement as the Persian voucher, mirrored: label on the left, signed amount
// right-aligned on the right so the figures line up.
export const PriceDetails = ({ data, currency }: PriceDetailsProps) => {
  const rows = priceRows(data)

  return (
    <View style={styles.mainDiv}>
      <View style={styles.statement}>
        {rows.map((row) => (
          <View
            key={row.kind}
            style={row.isTotal ? [styles.line, styles.totalLine] : styles.line}>
            <PDFText style={row.isTotal ? styles.totalLabel : styles.lineLabel}>
              {LABEL[row.kind]}
            </PDFText>
            <PDFText style={[styles.amount, toneStyle(row)]}>
              {`${SIGN[row.sign]}${addCommaToPrice(row.amount)} ${currency}`}
            </PDFText>
          </View>
        ))}
      </View>
      <View style={styles.priceTitleContainer}>
        <PDFText style={styles.subtitle}>Price Details</PDFText>
      </View>
    </View>
  )
}
